import { Link } from 'react-router-dom';
import styles from './NewsLinkButton.module.scss';

const IconSvgAlert = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.99611 11.2001C8.16511 11.2001 8.30794 11.1426 8.42461 11.0276C8.54128 10.9126 8.59961 10.7701 8.59961 10.6001V7.8001C8.59961 7.6301 8.54244 7.4876 8.42811 7.3726C8.31378 7.2576 8.17211 7.2001 8.00311 7.2001C7.83411 7.2001 7.69128 7.2576 7.57461 7.3726C7.45794 7.4876 7.39961 7.6301 7.39961 7.8001V10.6001C7.39961 10.7701 7.45678 10.9126 7.57111 11.0276C7.68544 11.1426 7.82711 11.2001 7.99611 11.2001ZM7.99611 6.0001C8.16511 6.0001 8.30794 5.94293 8.42461 5.8286C8.54128 5.71426 8.59961 5.5726 8.59961 5.4036C8.59961 5.2346 8.54244 5.09176 8.42811 4.9751C8.31378 4.85843 8.17211 4.8001 8.00311 4.8001C7.83411 4.8001 7.69128 4.85726 7.57461 4.9716C7.45794 5.08593 7.39961 5.2276 7.39961 5.3966C7.39961 5.5656 7.45678 5.70843 7.57111 5.8251C7.68544 5.94176 7.82711 6.0001 7.99611 6.0001ZM8.00428 14.4001C7.12339 14.4001 6.29405 14.2334 5.51628 13.9001C4.7385 13.5668 4.05794 13.1084 3.47461 12.5251C2.89128 11.9418 2.43294 11.2614 2.09961 10.4841C1.76628 9.70676 1.59961 8.87621 1.59961 7.99243C1.59961 7.10865 1.76628 6.28065 2.09961 5.50843C2.43294 4.73621 2.89128 4.05843 3.47461 3.4751C4.05794 2.89176 4.73828 2.43343 5.51561 2.1001C6.29294 1.76676 7.1235 1.6001 8.00728 1.6001C8.89105 1.6001 9.71905 1.76676 10.4913 2.1001C11.2635 2.43343 11.9413 2.89176 12.5246 3.4751C13.1079 4.05843 13.5663 4.73743 13.8996 5.5121C14.2329 6.28687 14.3996 7.11465 14.3996 7.99543C14.3996 8.87632 14.2329 9.70565 13.8996 10.4834C13.5663 11.2612 13.1079 11.9418 12.5246 12.5251C11.9413 13.1084 11.2623 13.5668 10.4876 13.9001C9.71283 14.2334 8.88505 14.4001 8.00428 14.4001ZM7.99961 13.2001C9.44405 13.2001 10.6718 12.6945 11.6829 11.6834C12.6941 10.6723 13.1996 9.44454 13.1996 8.0001C13.1996 6.55565 12.6941 5.32788 11.6829 4.31676C10.6718 3.30565 9.44405 2.8001 7.99961 2.8001C6.55516 2.8001 5.32739 3.30565 4.31628 4.31676C3.30516 5.32788 2.79961 6.55565 2.79961 8.0001C2.79961 9.44454 3.30516 10.6723 4.31628 11.6834C5.32739 12.6945 6.55516 13.2001 7.99961 13.2001Z"
        fill="#E83838"
      />
    </svg>
  );
};

const IconSvgArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.21967 0.219783C0.512563 -0.07311 0.987437 -0.07311 1.28033 0.219783L5.34619 4.28565L1.28033 8.35151C0.987437 8.6444 0.512563 8.6444 0.21967 8.35151C-0.0732234 8.05862 -0.0732234 7.58374 0.21967 7.29085L3.22487 4.28565L0.21967 1.28044C-0.0732233 0.98755 -0.0732233 0.512676 0.21967 0.219783Z"
        fill="#E83838"
      />
    </svg>
  );
};

export const NewsLinkButton = ({ newsNumber }: { newsNumber: string }) => {
  return (
    <Link to={`/menu/news#${newsNumber}`} className={styles.button}>
      <div className={styles.buttonContent}>
        <IconSvgAlert />
        <div>このスポットについてのお知らせがあります</div>
      </div>
      <IconSvgArrowRight />
    </Link>
  );
};
